<template>
  <div
    class="sidebar"
    style="background: red; height: 100%; position: fixed; z-index: 2000"
  >
    <el-row class="tac menu_page">
      <el-col :span="12" > 
        <el-menu
          class="el-menu-vertical-demo"
          default-active="1-1"
          :unique-opened="true"
          @open="handleOpen"
          @close="handleClose"
          background-color="#324057"
          style="height:100%;"
          :collapse="isCollapse"
        >
          <!-- <el-menu-item index="1" style="text-align:left">
             
               <div style="text-align:left;margin-left:-30px" @click="handleLeftMenu">
         <i :class="'fa fa-margin fa-arrow-'+left" style=" display: inline-block;" ></i>
              <span style="color:#fff">收起</span>
               </div>
             
      </el-menu-item> -->
       
          <el-submenu
            :index="(index + 1).toString()"
            v-for="(item, index) in menuList"
            :key="index"
            v-show="Roleid==item.msg||Roleid==item.msg2"
          >
            <template slot="title">
              <i
                :class="'fa fa-margin ' + item.actionPic"
                style="display: inline-block"
              ></i>
              <span style="color: #fff">{{ item.permissionName }}</span>
            </template>
            <el-menu-item-group>
              <router-link
                v-for="(citem, cindex) in item.child"
                :key="cindex"
                :to="citem.pmUrl"
                v-show="citem.cmsg==Roleid||citem.cmsg2==Roleid"
              >
                <el-menu-item
                  :index="
                    (index + 2).toString() + '-' + (cindex + 1).toString()
                  "
                >
                  <span style="color: #fff" class="font"
                    >{{ citem.permissionName }}
                  </span>
                </el-menu-item>
              </router-link>
            </el-menu-item-group>
          </el-submenu>
        </el-menu>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import * as mutils from "@/utils/mUtils";

export default {
  name: "left-Menu",
  data() {
    return {
      windowWidth: document.documentElement.clientWidth, //实时屏幕宽度
      windowHeight: document.documentElement.clientHeight, //实时屏幕高度
      lketg: false,
      left: "left",
      // changeBarDirection:false,
      screenWidth: document.body.clientWidth, // 屏幕宽度
      screenHeight: document.body.clientHeight, // 屏幕高度
      roleId: "",
      Roleid: "",
      menuList: [
        {
          permissionName: "订单",
          msg:1,
          actionPic: "fa-shopping-cart",
          child: [
            {
              permissionName: "订单列表",
              pmUrl: "/orderList",
              cmsg:1
            },
            {
              permissionName: "创建订单",
              pmUrl: "/addOrder",
              cmsg:1
            },
            {
              permissionName: "发货单",
              pmUrl: "/dispathchList",
              cmsg:1
            },
            {
              permissionName: "快递收货",
              pmUrl: "/checkExpress",
              cmsg:1
            }
          ],
        },
        {
          permissionName: "库存",
          actionPic: "fa-archive",
          msg:1,
          child: [
            {
              permissionName: "出入记录",
              pmUrl: "/goOutList",
              cmsg:1
            },
            {
              permissionName: "库存列表",
              pmUrl: "/repertoryList",
              cmsg:1
            },
          ],
        },
        {
          permissionName: "货运",
          actionPic: "fa-truck",
          msg:1,
          child: [
            {
              permissionName: "仓库管理",
              pmUrl: "/houserAddress",
              cmsg:1
            },
            {
              permissionName: "货物价格",
              pmUrl: "/priceGoods",
              cmsg:1
            },
            {
              permissionName: "货运管理",
              pmUrl: "/transport/list",
              cmsg:1
            },
          ],
        },
        {
          permissionName: "人员",
          actionPic: "fa-user-circle",
          msg:1,
          child: [
            {
              permissionName: "客户列表",
              pmUrl: "/customerList",
              cmsg:1
            },
            {
              permissionName: "员工管理",
              pmUrl: "/adminList",
              cmsg:1
            },
            {
              permissionName: "通知公告",
              pmUrl: "/announcement",
              cmsg:1
            },
          ],
        },
        {
          permissionName: "工单",
          actionPic: "fa-user-circle",
          msg:1,
          child: [
            {
              permissionName: "工单列表",
              pmUrl: "/workOrderList",
              cmsg:1
            },
            {
              permissionName: "工单须知",
              pmUrl: "/workOrderRemark",
              cmsg:1
            },
          ],
        },
        {
          permissionName: "加拿大分舵",
          actionPic: "el-icon-s-promotion",
          msg:1,
          msg2:3,
          child: [
            {
              permissionName: "地址配置",
              pmUrl: "/delivery/list",
              cmsg:1
            },{
              permissionName: "物流管理",
              pmUrl: "/delivery/order",
              cmsg:1,
              cmsg2:3
            }
            // Commented out unused appointment features
            // ,{
            //   permissionName: "预约订单",
            //   pmUrl: "/delivery/book",
            //   cmsg:1,
            //   cmsg2:3
            // }
            // ,{
            //   permissionName: "预约配置",
            //   pmUrl: "/delivery/config",
            //   cmsg:1,
            //   cmsg2:3
            // }
            ,{
              permissionName: "扫码入库",
              pmUrl: "/delivery/fastIn",
              cmsg:1,
              cmsg2:3
            },
            {
              permissionName: "发货单",
              pmUrl: "/delivery/dispathchList",
              cmsg:1,
              cmsg2:3
            },
            {
              permissionName: "客户列表",
              pmUrl: "/delivery/newCustomer",
              cmsg:1,
              cmsg2:3
            },
            
          ],
        },{
          permissionName: "加拿大中心仓",
          actionPic: "el-icon-s-shop",
          msg:1,
          msg2:2,
          child: [
            {
              permissionName: "中心仓库管理",
              pmUrl: "/distribution/list",
              cmsg:1,
            },{
              permissionName: "物流管理",
              pmUrl: "/distribution/order",
              cmsg:1,
              cmsg2:2,
            },{
              permissionName: "扫码入库",
              pmUrl: "/distribution/fastInStorage",
              cmsg:1,
              cmsg2:2,
            },{
              permissionName: "派送列表",
              pmUrl: "/delivery/deliveryList",
              cmsg:1,
              cmsg2:2
            },
            {
              permissionName: "扫码出库",
              pmUrl: "/distribution/outStorage",
              cmsg:1,
              cmsg2:3
            }
          ],
        },
         {
          permissionName: "充值",
          actionPic: "el-icon-s-finance",
          msg:1,
          child: [
            {
              permissionName: "财务账号",
              pmUrl: "/recharge/account",
              cmsg:1,
            },
            {
              permissionName: "财务流动",
              pmUrl: "/recharge/flows",
              cmsg:1,
            },
            {
              permissionName: "充值",
              pmUrl: "/recharge/charge",
              cmsg:1,
            },
            {
              permissionName: "调账",
              pmUrl: "/recharge/adjust",
              cmsg:1,
            },
            {
              permissionName: "汇率",
              pmUrl: "/recharge/rate",
              cmsg:1,
            }
          ],
        },
        {
          permissionName: "设置",
          actionPic: "el-icon-setting",
          msg:1,
          child: [
            {
              permissionName: "协议条款",
              pmUrl: "/system/agree",
              cmsg:1,
            },
            {
              permissionName: "首页公告",
              pmUrl: "/system/notice",
              cmsg:1,
            },
          ],
        },
        {
          permissionName: "统计",
          actionPic: "el-icon-tickets",
          msg:1,
          msg2:3,
          child: [
            {
              permissionName: "运单",
              pmUrl: "/statistical/wayBill",
              cmsg:1,
              cmsg2:3
            },
            {
              permissionName: "费用",
              pmUrl: "/statistical/cost",
              cmsg:1,
              cmsg2:3
            },
            
          ],
        },
      ],
      // nowIndex: '0',
      isCollapse: false,
    };
  },
  watch: {
    "$store.state.menu.isDropname": function () {
      this.isCollapse = this.$store.state.menu.isCollapse;
    },
    windowHeight(val) {
      let that = this;
      // console.log("实时屏幕高度：",val, that.windowHeight );
    },
    windowWidth(val) {
      let that = this;
      // console.log("实时屏幕宽度：",val, that.windowHeight );
    },
  },

  mounted() {
    var that = this;
    // <!--把window.onresize事件挂在到mounted函数上-->
    window.onresize = () => {
      return (() => {
        window.fullHeight = document.documentElement.clientHeight;
        window.fullWidth = document.documentElement.clientWidth;
        that.windowHeight = window.fullHeight; // 高
        that.windowWidth = window.fullWidth; // 宽
      })();
    };
  },
  //     mounted(){
  //   this.nowIndex=this.$route.matched[0].path
  //   // console.log(this.$route.matched[0].path)
  // },
  computed: {
    nowIndex() {
      // this.$route.path
      // debugger
      // console.log(this.$route.path.replace('/',''))
      if (this.$route.path.replace("/", "") == "productList") {
        return "2-1";
      } else if (this.$route.path.replace("/", "") == "newProduct") {
        return "2-2";
      } else if (this.$route.path.replace("/", "") == "hsCoding") {
        return "3-3";
      } else if (this.$route.path.replace("/", "") == "newOrder") {
        return "3-1";
      } else if (this.$route.path.replace("/", "") == "salesOrder") {
        return "3-2";
      } else if (this.$route.path.replace("/", "") == "purchaseOrderList") {
        return "3-3";
      } else if (this.$route.path.replace("/", "") == "shippingAssistant") {
        return "4-1";
      } else if (this.$route.path.replace("/", "") == "orderDelivery") {
        return "4-2";
      } else if (this.$route.path.replace("/", "") == "preliminaryRecord") {
        return "4-3";
      } else if (this.$route.path.replace("/", "") == "purchaseASaleContract") {
        return "6-4";
      } else if (this.$route.path.replace("/", "") == "customer") {
        return "5-1";
      } else if (this.$route.path.replace("/", "") == "factory") {
        return "5-2";
      } else if (this.$route.path.replace("/", "") == "employee") {
        return "5-3";
      } else if (this.$route.path.replace("/", "") == "addRateTax") {
        return "6-1";
      } else if (this.$route.path.replace("/", "") == "orderStatistics") {
        return "6-2";
      } else if (this.$route.path.replace("/", "") == "shipmentStatistics") {
        return "6-3";
      } else if (this.$route.path.replace("/", "") == "companyInformation") {
        return "7-1";
      } else if (
        this.$route.path.replace("/", "") == "orderStatisticsDelivery"
      ) {
        return "6-2";
      } else if (
        this.$route.path.replace("/", "") == "shipmentStatisticsDelivery"
      ) {
        return "6-3";
      }
      //   else if(this.$route.path.replace('/','')=='hsCoding'){
      //     return 'hsCoding'
      // }
      //   else if(this.$route.path.replace('/','')=='hsCoding'){
      //     return 'hsCoding'
      // }
      //   else if(this.$route.path.replace('/','')=='hsCoding'){
      //     return 'hsCoding'
      // }
    },
  },

  // computed:{
  //     isDropname(){  // false
  //        return this.$store.state.menu.isDropname;
  //     }

  // },
  //收缩
  //  mounted() {
  //       const that = this;
  //       window.onresize = () => {
  //           return (() => {
  //               window.screenWidth = document.body.clientWidth+35;
  //               window.screenHeight = document.body.clientHeight;
  //               console.log( window.screenWidth)
  //             		// this.$store.dispatch('set_win_content',win_size);
  //           })
  //       }

  //   },

  // watch: {
  //     // 如果 `question` 发生改变，这个函数就会运行
  //     clientWidth: function (newQuestion, oldQuestion) {
  //           this
  //     }
  // },
  created() {
    this.roleId = Number(mutils._getCookie("roleId"));
    this.Roleid = Number(mutils._getStore("roleId"));
    // console.log('ID:'+this.Roleid);
    //if (mutils.getToken()) {
    //this.getMenuList();
    //}
    // console.log(this.$store.state.menu.items);
  },
  methods: {
    handleLeftMenu() {
      let that = this;
      this.$store.dispatch("setLeftCollapse"); // 折叠菜单
      this.$store.dispatch("handleLeftMenu"); // 改变菜单宽度
      this.$store.dispatch("dropName"); // 隐藏单一菜单名称
      this.setSize();
      if (this.lketg) {
        that.left = "left";
        that.lketg = !that.lketg;
        mutils.setStore("lketg", that.lketg);
      } else {
        that.left = "right";
        that.lketg = !that.lketg;
        mutils.setStore("lketg", that.lketg);
      }
    },
    setSize() {
      let win_size = {};
      let that = this;
      if (this.lketg) {
        window.fullHeight = document.documentElement.clientHeight - 50;
        window.fullWidth = document.documentElement.clientWidth - 141;
        that.windowHeight = window.fullHeight; // 高
        that.windowWidth = window.fullWidth; // 宽
        // console.log(document.documentElement.clientHeight, document.documentElement.clientWidth)
        win_size = {
          // width:(this.$store.state.menu.sidebar.opened)? this.$$lib_$(window).width()-180:this.$$lib_$(window).width()-35,
          width: that.windowWidth,
          height: that.windowHeight,
        };
      } else {
        win_size = {
          // width:(this.$store.state.menu.sidebar.opened)? this.$$lib_$(window).width()-180:this.$$lib_$(window).width()-35,
          width: this.$store.state.menu.sidebar.opened
            ? document.body.clientWidth - 15
            : document.body.clientWidth - 15,
          height: document.body.clientHeight - 50,
        };
      }
      //将content部分的宽高，存入store中，
      this.$store.dispatch("set_win_content", win_size);
    },
    //   setSize() {
    // 	const win_size = {
    // 		// width:(this.$store.state.menu.sidebar.opened)? this.$$lib_$(window).width()-180:this.$$lib_$(window).width()-35,
    // 		width:(this.$store.state.menu.sidebar.opened)? document.body.clientWidth-180:document.body.clientWidth-35,
    // 		height:document.body.clientHeight-73
    // 	}
    // 	console.log(win_size);
    // 	//将content部分的宽高，存入store中，
    // 	this.$store.dispatch('set_win_content',win_size);
    // },
    // handleLeftMenu(){
    //     this.$store.dispatch('setLeftCollapse');  // 折叠菜单
    // 	this.$store.dispatch('handleLeftMenu');  // 改变菜单宽度
    // 	this.$store.dispatch('dropName');   // 隐藏单一菜单名称
    // 	this.setSize()
    // 	// this.changeBarDirection = !this.changeBarDirection;
    // },
    // getMenuList() {
    //   var that = this;

    //   that.$sub.post('/v1/admin/getUserPermission', {
    //       adminId: mutils.getUserId(),
    //       token: mutils.getToken()
    //     })
    //     .then(function (res) {
    //       //console.log("res:"+JSON.stringify(res.data.data.list));
    //       that.menuList = res.data.data.list;
    //     })

    //   //return this.$store.state.menu.items;
    // },
    handleOpen(key, keyPath) {
      // console.log( keyPath);
    },
    handleClose(key, keyPath) {
      // console.log( keyPath);
    },
  },
};
</script>


<style lang="less" scoped>
.menu_page {
  position: fixed;
  top: 70px;
  left: 0;
  bottom: 0;
  /* min-height:100%;
  background-color: #324057; */
  z-index: 99;
  min-height: 90.5vh;
  overflow: auto;
  background-color: #324057;
}

.fa-margin {
  margin-right: 5px;
}

.el-menu-vertical-demo:not(.el-menu--collapse) {
  width: 180px;
  min-height: 95.5vh;
}

.el-menu-vertical-demo {
  width: 35px;
  
}

.el-submenu .el-menu-item {
  min-width: 180px;
}

.el-menu {
  .el-menu-item {
    padding-left: 40px !important;
  }
}

.hiddenDropdown,
.hiddenDropname {
  display: none;
}

.el-submenu__title {
  color: #ff6428 !important;
}

.verity:hover {
  background-color: rgb(40, 51, 70);
}
.verity:focus {
  background-color: #324057 !important;
}
.el-menu-item:focus {
  background-color: rgb(40, 51, 70) !important;
  // color: #ffd04b !important;
}

.is-active:focus {
  background-color: rgb(40, 51, 70) !important;
  // background-color: rgb(40, 51, 70) !important;
}
</style>


// WEBPACK FOOTER //
// leftMenu.vue?691d54c7